import axios from '../config/axios';

const API_BASE = '/vehicles';

const vehicleService = {
  // Get all vehicles with filters
  getAll: (filters = {}) => {
    return axios.get(API_BASE, { params: filters });
  },

  // Get all vehicles with pagination
  getAllVehicles: (page = null, perPage = null, filters = {}) => {
    const params = {
      ...(page && { page }),
      ...(perPage && { per_page: perPage }),
      ...filters
    };
    return axios.get(API_BASE, { params });
  },

  // Get single vehicle
  getVehicle: (vehicleId) => {
    return axios.get(`${API_BASE}/${vehicleId}`);
  },

  // Get vehicle by ID (alias)
  getById: (vehicleId) => {
    return axios.get(`${API_BASE}/${vehicleId}`);
  },

  // Create vehicle
  createVehicle: (data) => {
    // Check if data is FormData
    if (data instanceof FormData) {
      return axios.post(API_BASE, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return axios.post(API_BASE, data);
  },

  // Update vehicle
  updateVehicle: (vehicleId, data) => {
    // Check if data is FormData
    if (data instanceof FormData) {
      return axios.put(`${API_BASE}/${vehicleId}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return axios.put(`${API_BASE}/${vehicleId}`, data);
  },

  // Delete vehicle
  deleteVehicle: (vehicleId) => {
    return axios.delete(`${API_BASE}/${vehicleId}`);
  },

  // Get active vehicles
  getActiveVehicles: () => {
    return axios.get(`${API_BASE}/active`);
  },

  // Get vehicles by type
  getVehiclesByType: (vehicleType) => {
    return axios.get(`${API_BASE}/type/${vehicleType}`);
  },

  // Activate vehicle
  activateVehicle: (vehicleId) => {
    return axios.post(`${API_BASE}/${vehicleId}/activate`);
  },

  // Get policy document URL
  getPolicyDocument: (vehicleId) => {
    return `${axios.defaults.baseURL}${API_BASE}/${vehicleId}/policy-document`;
  },

  // Get vehicle RC URL
  getVehicleRC: (vehicleId) => {
    return `${axios.defaults.baseURL}${API_BASE}/${vehicleId}/vehicle-rc`;
  },

  // Get PUC URL
  getPUC: (vehicleId) => {
    return `${axios.defaults.baseURL}${API_BASE}/${vehicleId}/puc`;
  },

  // Get purchase invoice URL
  getPurchaseInvoice: (vehicleId) => {
    return `${axios.defaults.baseURL}${API_BASE}/${vehicleId}/purchase-invoice`;
  },

  // Get vehicles with expiring insurance
  getExpiringInsurance: (days = 30) => {
    return axios.get(`${API_BASE}/insurance/expiring`, { params: { days } });
  },

  // Get vehicles with expired insurance
  getExpiredInsurance: () => {
    return axios.get(`${API_BASE}/insurance/expired`);
  },

  // Get vehicle by ID (another alias for consistency)
  getVehicleById: (vehicleId) => {
    return axios.get(`${API_BASE}/${vehicleId}`);
},
};

// Export as default
export default vehicleService;